import { AxiosInstance } from "axios";
import type { AsanaProject, AsanaWorkspace } from "./AsanaSourceSettings.types";

export class AsanaSourceSettingsApi {
  constructor(private readonly client: AxiosInstance) {}

  async getWorkspaces(
    boardId: string,
    connectionId: string,
  ): Promise<AsanaWorkspace[]> {
    const response = await this.client.get<AsanaWorkspace[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/asana/workspaces`,
    );
    return response.data;
  }

  async getProjects(
    boardId: string,
    connectionId: string,
    workspaceGid: string,
  ): Promise<AsanaProject[]> {
    const response = await this.client.get<AsanaProject[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/asana/workspaces/${encodeURIComponent(workspaceGid)}/projects`,
    );
    return response.data;
  }
}
